import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';

import { LanguageContext } from '@mssgme/hooks';
import { CardContainer, CardRoutes } from '@mssgme/cards';
import { NotificationsBagLegacy, ExperimentsProvider } from '@mssgme/ui';
import styles from './styles.scss';

// const ab = {
//     experiments: [
//         {
//             id: 'branding',
//             variants: [
//                 { id: 'both', weight: 25 },
//                 { id: 'top', weight: 25 },
//                 { id: 'large', weight: 25 },
//                 { id: 'medium', weight: 25 },
//             ],
//         },
//     ],
// };

function Userpage({ basename, data: { card, mode }, lang = 'en' }) {
    return (
        <Router basename={basename}>
            <LanguageContext.Provider value={lang}>
                {/*<ExperimentsProvider config={ab}>*/}
                <div className={styles.root}>
                    <NotificationsBagLegacy />
                    <CardContainer>
                        <CardRoutes
                            data={card}
                            widgetMode={mode === 'embed'}
                            paths={{
                                home: '/',
                                collection: '/c/:collectionSlug',
                                product: '/p/:productSlug',
                            }}
                        />
                    </CardContainer>
                </div>
                {/*</ExperimentsProvider>*/}
            </LanguageContext.Provider>
        </Router>
    );
}

Userpage.propTypes = {
    basename: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    lang: PropTypes.string,
};

export default Userpage;
